import { useStore } from 'vuex'
import { Cookies } from 'quasar'
import { useRoute, useRouter } from 'vue-router'

import { appStorage } from 'src/common/functions'
import { sendDataToTDS } from 'src/services/tds'
// import afpl from 'src/common/AppsFlyerParseLink'

export function useHandleQueries() {
  const route = useRoute()
  const router = useRouter()

  const store = useStore()

  router.isReady().then(() => {
    handleTokenWebview()
    handleUtm()
    // checkModals()
  })

  // function checkModals() {
  //   const modalName = route.query.modal
  //   if (!modalName) {
  //     return
  //   }
  //
  //   const MODAL_LIST = {
  //     login: {
  //       auth: false,
  //       guest: true,
  //       action: () => console.log('Login modal opened'),
  //     },
  //     register: {
  //       auth: false,
  //       guest: true,
  //       action: () => console.log('Register modal opened'),
  //     },
  //     profile: {
  //       auth: true,
  //       guest: false,
  //       action: () => console.log('Profile modal opened'),
  //     },
  //     help: {
  //       auth: null,
  //       guest: null,
  //       action: () => console.log('Help modal opened'),
  //     },
  //   }
  //
  //   const handler = MODAL_LIST[modalName]
  //   if (handler) {
  //     if (isAuth.value && handler.auth === false) {
  //       console.warn('Эта модалка не доступна авторизованным пользователям.')
  //       return
  //     }
  //     if (!isAuth.value && handler.guest === false) {
  //       console.warn('Эта модалка не доступна гостям.')
  //       return
  //     }
  //
  //     handler.action()
  //   } else {
  //     console.warn(`Модалка "${modalName}" не найдена.`)
  //   }
  // }

  function handleTokenWebview() {
    const token = route.query.a_ssid
    const app_type = route.query.app_type
    const mb_uuid = route.query.mb_uuid

    if (app_type) {
      const storage = appStorage(store)
      storage.setItem('a_ssid', token)
      storage.setItem('app_type', app_type)
      storage.setItem('mb_uuid', mb_uuid)
    }
  }

  function handleUtm() {
    const UTM_MARKERS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'rich_ref',
      'click_id',
      'partner',
      'pid',
      'modal',
      'sub_id',
    ]

    const query = route.query
    const urlHasMarker = Object.keys(query).some((item) => UTM_MARKERS.includes(item))

    if (!urlHasMarker) {
      return
    }

    const queriesForSave = Object.keys(query).reduce((acc, key) => {
      if (query[key] === null) {
        return acc
      }
      acc[key] = query[key]

      return acc
    }, {})

    const currentTime = new Date()
    currentTime.setDate(currentTime.getDate() + 30)

    Cookies.set('ref_data', JSON.stringify(queriesForSave), { path: '/', expires: currentTime.toUTCString() })
    sendDataToTDS(queriesForSave, route.query, store.getters.getUserIp, store.getters.getRealRegion)

    // sendDataToDWH(queriesForSave)
  }

  /**
  function sendDataToDWH(queries) {
    afpl.queries = queries
    const affiliateData = afpl.getDataDWH()
    const timestamp = +new Date()

    const payload = {
      pageVisitMessages: [
        {
          userId: store.getters.getUser?.id,
          deviceId: store.getters.getUserIp,
          timestamp,
          geo: store.getters.getRealRegion,
          pageType: 'ELSE',
          affiliateData,
        },
      ],
      datasource: {
        origin: process.env.ENVIRONMENT === 'production' ? 'OC' : 'TEST',
        platform: 'CASINO',
      },
    }

    store.$axios.statistic.send(payload).catch(() => {})
  }
  **/
}
